export const ERROR_CODES = {
  PROCESSING_EMAIL_ENRICHMENT: 4001006, // happens when: simultaneously processing email enrichment limit reached
};
